import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Doughnut, Bar } from "react-chartjs-2";
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, BarElement, CategoryScale, LinearScale } from "chart.js";
import DataTable from "react-data-table-component";
import './style.css'
// Register necessary Chart.js components
ChartJS.register(Title, Tooltip, Legend, ArcElement, BarElement, CategoryScale, LinearScale);

const ReportViewPage = () => {
    const navigate = useNavigate();
    const [lead, setLead] = useState(null);

    // Simulated table data
    const tableData = [
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "1"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "1"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "1"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "1"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "1"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "1"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "1"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "1"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "1"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "1"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "1"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "1"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "1"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "1"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "1"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "1"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "1"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "1"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "1"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "1"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "2"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "2"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "2"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "2"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "2"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "2"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "2"// Approved = 1 Rejected 2
        },
        {
            date: "02-12-2024 4:23 PM",
            lead: "1",
            status: "2"// Approved = 1 Rejected 2
        },

    ]

    // Retrieve lead data from session storage
    useEffect(() => {
        const storedLead = sessionStorage.getItem("selectedLead");
        if (storedLead) {
            setLead(JSON.parse(storedLead));
        } else {
            navigate("/");
        }
    }, [navigate]);

    if (!lead) {
        return <p>Loading lead details...</p>;
    }

    // Donut chart data: Approved vs Rejected Leads
    const donutChartData = {
        labels: ["Approved Leads", "Rejected Leads"],
        datasets: [
            {
                data: [lead.approvedLeads, lead.rejectedLeads],
                backgroundColor: ["#4caf50", "#f44336"], // Green for approved, Red for rejected
                borderWidth: 1,
            },
        ],
    };

    // Aggregate the total Approved and Rejected leads
    const approvedLeadsCount = tableData.filter(item => item.status === "1").length;
    const rejectedLeadsCount = tableData.filter(item => item.status === "2").length;

    // Bar chart data: Total Approved and Rejected Leads
    const barChartData = {
        labels: ["Leads"],
        datasets: [
            {
                label: "Approved Leads",
                data: [approvedLeadsCount], // Single bar for Approved Leads
                backgroundColor: "#4caf50",
            },
            {
                label: "Rejected Leads",
                data: [rejectedLeadsCount], // Single bar for Rejected Leads
                backgroundColor: "#f44336",
            },
        ],
    };

    // DataTable columns
    const columns = [
        {
            name: "Date",
            selector: (row) => moment(row.date, "DD-MM-YYYY h:mm A").format("MMMM Do YYYY, h:mm:ss a"),
            sortable: true,
        },
        {
            name: "Lead",
            selector: (row) => row.lead,
            sortable: true,
        },
        {
            name: "Status",
            selector: (row) => (row.status === "1" ? "Approved" : "Rejected"),
            sortable: true,
        },
    ];

    return (
        <div className="container">
            <button className="back-btn mb-5" onClick={() => navigate(-1)}>
                Back to Reports
            </button>
            <div className="charts">
                <div className="chart-card">
                    <h3 className="chart-title">Lead Status</h3>
                    <div className="chart-container">
                        <Doughnut data={donutChartData} />
                    </div>
                </div>

                <div className="chart-card">
                    <h3 className="chart-title">Approved vs Rejected Leads</h3>
                    <div className="chart-container">
                        <Bar data={barChartData} options={{ responsive: true }} />
                    </div>
                </div>
            </div>

            <div className="table-container">
                <h3 className="table-title">Lead Data</h3>
                <DataTable
                    columns={columns}
                    data={tableData}
                    pagination
                    responsive
                    paginationPerPage={5}
                    highlightOnHover
                    pointerOnHover
                />
            </div>


        </div>
    );
};

export default ReportViewPage;
